export const SET_TOKEN="set_token"
export const SET_USER_INFO="set_userInfo"